export const base = {
  none: "none",
  uppercase: "uppercase",
}

export type Base = Record<keyof typeof base, string>
